"use strict";

Math.mod = function(n, m) {
    return ((n % m) + m) % m;
}

Math.validate = function(n) {
    return n.toString().indexOf("e") == -1 ? n : 0;
}

Math.radiansToDegrees = function(r) {
    return r * 57.2958;
}

Math.degreesToRadians = function(d) {
    return d * 0.0174533;
}

Math.pingPong = function(t,l) {
    //return (t % 2) > 1 ? l * 2 - (t % 2) : (t % 2);
    return (t % (l * 2)) > l ? l * 2 - (t % (l * 2)) : (t % (l * 2));
}

Math.pingPong01 = function(t) {
    return Math.pingPong(t, 0.5) / 1;
}

Math.floatate = function(bottom,t,speed,traverseHeight) {
    return bottom - ((Math.cos(t * speed) * 2 + 1) / 2) * traverseHeight;
}

Math.getDelta = function(value,min,max) {
    return Math.clamp((value - min) / (max - min), 0, 1);
}

Math.fromDelta = function(delta,min,max) {
    return (max - min) * delta + min;
}

Math.clamp = function(value,min,max) {
    return value < min ? min : value > max ? max : value;
}

Math.clamp01 = function(value) {
    return value < 0 ? 0 : value > 1 ? 1 : value;
}

Math.lerp = function(min,max,delta) {
    return (1 - delta) * min + delta * max;
}

Math.getRandomInt = function(min,max) {
    return Math.floor(min + Math.random() * (max - min));
}

Math.getRandomFloat = function(min,max) {
    return min + Math.random() * (max - min);
}

Math.moveTowards = function(current,target,maxDelta) {
    if (Math.abs(target - current) <= maxDelta) return target;
    return current + Math.sign(target - current) * maxDelta;
}